import Vue from 'vue'
import { TestStatus } from '@shared/types/database'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import formatRelative from 'date-fns/formatRelative'
import { format as dateFormat } from 'date-fns'
import fromUnixTime from 'date-fns/fromUnixTime'

Vue.filter('capitalize', function (value: string): string {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('commaList', function (value: string, index: number, arrayLength: number): string {
  if (index < arrayLength - 1) {
    value = value + ', '
  }
  return value
})

Vue.filter('criteriaDisplayValue', function (value: string, audienceKey: string): string {
  const genderMap: Record<string, string> = {
    1: 'Male',
    2: 'Female'
  }
  switch (audienceKey) {
    case 'Age':
      return `${value[0]} - ${value[value.length - 1]}`
    case 'Gender':
      return genderMap[value[0]]
    case 'Additional Criteria':
      return value
    default:
      console.warn('No audience criteria value parser available for:', audienceKey)
      return value
  }
})

Vue.filter('dateFormat', function (timestamp: number, format?: 'MMM Do YYYY'): string {
  var timeNow = Math.floor(Date.now() / 1000)
  var startTimeToday = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000)
  var startTimeYesterday = startTimeToday - 86400

  if ((timeNow - timestamp) < 3600) {
    return `${formatDistanceToNow(timestamp * 1000)} ago`
  } else if ((timeNow - timestamp) < 86400) {
    if (startTimeToday < timestamp) {
      return `${formatDistanceToNow(timestamp * 1000)} ago`
    } else {
      const timeDifference = formatRelative(timestamp * 1000, Date.now())
      return `${timeDifference[0].toLocaleUpperCase()}${timeDifference.slice(1)}`
    }
  } else {
    if (startTimeYesterday < timestamp) {
      const timeDifference = formatRelative(timestamp * 1000, Date.now())
      return `${timeDifference[0].toLocaleUpperCase()}${timeDifference.slice(1)}`
    } else {
      const time:Date = fromUnixTime(timestamp)
      return dateFormat(time, 'MM/dd/yy')
    }
  }
})

Vue.filter('stripHtml', function (value: string): string {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/&amp;/g, '&')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&quot;/g, '\"')
    .replace(/&#039;/g, '\'')
})

Vue.filter('statusDisplay', function (value: TestStatus): string {
  return statusDisplay(value)
})

export function statusDisplay (value: TestStatus): string {
  switch (value.toLowerCase()) {
    case 'in review':
      return 'Submitted'
    case 'in progress':
      return 'In progress'
    case 'complete':
      return 'Completed'
    default:
      return value
  }
}
